import { createContext } from 'react'

import { createKindAllNodeStringStore } from '../store/createStore'

export const KindAllNodeStringStoreContext = createContext<
  ReturnType<typeof createKindAllNodeStringStore> | undefined
>(undefined)
